import { createContext } from 'react';

export const DrillContext = createContext(1);